import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders, uaeProjectsBaseURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_AUTOCOMPLETE_LOCATION, GET_AUTOCOMPLETE_LOCATION_ERROR, GET_AUTOCOMPLETE_LOCATION_SUCCESS } from '../../actions';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* getAutoCompleteLocation({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/v1/autocomplete-location`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_AUTOCOMPLETE_LOCATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_AUTOCOMPLETE_LOCATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_AUTOCOMPLETE_LOCATION_ERROR, payload: error });
  }
}

export function* watchGetAutoCompleteLocation() {
  yield takeEvery(GET_AUTOCOMPLETE_LOCATION, getAutoCompleteLocation);
}

function* getAutoCompleteLocationSaga() {
  yield all([fork(watchGetAutoCompleteLocation)]);
}

export default getAutoCompleteLocationSaga;
